module.exports = __webpack_public_path__ + "src/img/off.596d35e7.svg";